import moment from "moment";
import { actions } from "./action";

const INITIAL_STATE = {
  list: [],
  filters: {
    publisher: null,
    trafficType: null,
    orderBy: "date",
    orderDirection: "DESC",
    fromDate: moment().subtract(1, "days"),
    toDate: moment().subtract(1, "days")
  }
};

const ivtReduceer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.SET_IVT_LIST:
      return {
        ...state,
        list: action.payload
      };

    case actions.SET_IVT_FILTER:
      return {
        ...state,
        filters: action.payload
      };

    default:
      return state;
  }
};

export default ivtReduceer;
